import React from "react";
import CodeList from "../../lib/CodeList";
import Oceanlook from "../../lib/oceanlook";
import { useTranslation } from "react-i18next";

const codeList = new CodeList();
const oceanlook = new Oceanlook();

export default function LogiWorkLandingCarousel({
  loginInfo,
  setIsInquiryModalOpen,
}) {
  const { t } = useTranslation();
  return (
    <div
      className="p-3 p-xl-5 text-white NNS"
      style={{
        background: `url(/img/use_img/shutterstock_1810522879_1920.jpg) 50% 70%/cover no-repeat`,
      }}
    >
      <div className="my-5 container-xl">
        <div className="row m-0 p-0 ">
          <div className="col-xl-8 m-0 p-0 ">
            <p className="BM-DH h4 mb-1 mb-xl-3 ">
              {t("logiWorkLanding.carousel.title")}
            </p>
            <p className="BM-DH h1 mb-3 text-yellow">
              {t("logiWorkLanding.logiWork")}
              {t("logiWorkLanding.addedLogiWork")}
            </p>
            <div className="row m-0 mb-3 p-0 h6 text-light border-bottom border-white pb-3">
              <div className="col-12 col-lg-2 h5 m-0 mb-3 mb-lg-0 p-0 pl-2">
                <p className="font-weight-bold">
                  {t("logiWorkLanding.carousel.corp.title")}
                </p>
              </div>
              <div className="col-12 col-lg-10 text-left m-0 p-0">
                <ul className="ml-2">
                  <li className="mb-2">
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>{t("logiWorkLanding.carousel.corp.lowCost")}</p>
                      </div>
                      <p className="pl-2">
                        {t("logiWorkLanding.carousel.corp.lowCostDesc")}
                      </p>
                    </div>
                  </li>
                  <li className="mb-2">
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>{t("logiWorkLanding.carousel.corp.efficiency")}</p>
                      </div>
                      <p className="pl-2">
                        {t("logiWorkLanding.carousel.corp.efficiencyDesc")}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>{t("logiWorkLanding.carousel.corp.convenience")}</p>
                      </div>
                      <p className="pl-2">
                        {t("logiWorkLanding.carousel.corp.convenienceDesc")}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row m-0 mb-5 p-0 h6 text-light">
              <div className="col-12 col-lg-2 h5 m-0 mb-3 mb-lg-0 p-0 pl-2">
                <p className="font-weight-bold">
                  {t("logiWorkLanding.carousel.forwarder.title")}
                </p>
              </div>
              <div className="col-12 col-lg-10 text-left m-0 p-0">
                <ul className="ml-2">
                  <li className="mb-2">
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>
                          {t(
                            "logiWorkLanding.carousel.forwarder.corpPromotion"
                          )}
                        </p>
                      </div>
                      <p className="pl-2">
                        {t(
                          "logiWorkLanding.carousel.forwarder.corpPromotionDesc"
                        )}
                      </p>
                    </div>
                  </li>
                  <li className="mb-2">
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>
                          {t("logiWorkLanding.carousel.forwarder.salesTool")}
                        </p>
                      </div>
                      <p className="pl-2">
                        {t("logiWorkLanding.carousel.forwarder.salesToolDesc")}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex flex-row">
                      <div
                        className="font-weight-bold d-flex flex-row"
                        style={{ width: 110, minWidth: 110 }}
                      >
                        <p className="mr-2">·</p>
                        <p>
                          {t("logiWorkLanding.carousel.forwarder.efficiency")}
                        </p>
                      </div>
                      <p className="pl-2">
                        {t("logiWorkLanding.carousel.forwarder.efficiencyDesc")}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="BM-DH h5 text-center text-xl-center mb-3">
              <span className=" border-top border-bottom d-inline-block px-3 py-2">
                {t("logiWorkLanding.carousel.introductionEffect.title")}
              </span>
            </div>
            <div className="row m-0 mb-2 mb-xl-5 p-0">
              <div className="col-xl-4 py-2 m-0 p-xl-0 text-center">
                <p className="h1">
                  <i className="fa-regular fa-eye" />
                </p>
                <p className="h6 font-weight-bold mb-2 text-yellow">
                  {t("logiWorkLanding.carousel.introductionEffect.visibility")}
                </p>
                <p>
                  {t(
                    "logiWorkLanding.carousel.introductionEffect.visibilityDesc"
                  )}
                </p>
              </div>
              <div className="col-xl-4 py-2 m-0 p-xl-0 text-center">
                <p className="h1">
                  <i className="fa-solid fa-lock" />
                </p>
                <p className="h6 font-weight-bold mb-2 text-yellow">
                  {t("logiWorkLanding.carousel.introductionEffect.lockIn")}
                </p>
                <p>
                  {t("logiWorkLanding.carousel.introductionEffect.lockInDesc")}
                </p>
              </div>
              <div className="col-xl-4 py-2 m-0 p-xl-0 text-center">
                <p className="h1">
                  <i className="fa-solid fa-chart-line" />
                </p>
                <p className="h6 font-weight-bold mb-2 text-yellow">
                  {t("logiWorkLanding.carousel.introductionEffect.dashboard")}
                </p>
                <p>
                  {t(
                    "logiWorkLanding.carousel.introductionEffect.dashboardDesc"
                  )}
                </p>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-center">
              <button
                className="btn btn btn-light border-0 text-info"
                onClick={() => window.open("https://system.gbts.co.kr/")}
              >
                {t("logiWorkLanding.carousel.gotoLogiWork")}{" "}
                <i className="fa-solid fa-right-to-bracket" />
              </button>
              <button
                className="d-inline-block  btn btn btn-info bg-freiscop border-0 font-weight-bold ml-2"
                onClick={(e) => {
                  if (!loginInfo) {
                    codeList.Modal.current.alert(t("commonMSG.requiresLogin"));
                    return false;
                  }
                  oceanlook.openPopup();
                }}
              >
                <i className="fa-solid fa-ship" /> OCEANLOOK
              </button>
            </div>
            <div className="d-flex flex-column align-items-end d-xl-none text-right mt-5">
              <div className="mb-3">
                <button
                  className="btn btn-info rounded-circle"
                  style={{ width: 70, height: 70, lineHeight: "1.2em" }}
                  data-toggle="modal"
                  data-target="#popupRegistModal"
                >
                  {t("logiWorkLanding.join")}
                </button>
              </div>

              <div>
                <button
                  className="btn btn-secondary rounded-circle d-flex flex-row justify-content-center align-items-center"
                  style={{ width: 70, height: 70, lineHeight: "1.2em" }}
                  onClick={() => setIsInquiryModalOpen(true)}
                >
                  <span>{t("logiWorkLanding.serviceInquiry")}</span>
                </button>
              </div>
            </div>
          </div>
          <div className="col-xl-3 m-0 p-0 d-none d-xl-block">
            <div className="h-100 d-flex flex-column align-items-end justify-content-end">
              <div className="mb-3">
                <button
                  className="btn btn-info rounded-circle"
                  style={{ width: 70, height: 70, lineHeight: "1.2em" }}
                  data-toggle="modal"
                  data-target="#popupRegistModal"
                >
                  {t("logiWorkLanding.join")}
                </button>
              </div>

              <div>
                <button
                  className="btn btn-secondary rounded-circle d-flex flex-row justify-content-center align-items-center"
                  style={{ width: 70, height: 70, lineHeight: "1.2em" }}
                  onClick={() => setIsInquiryModalOpen(true)}
                >
                  <span>{t("logiWorkLanding.serviceInquiry")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
